import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import UpdateError from 'components/RwdCheckout/Shared/UpdateError/UpdateError';
import UpdateErrorEN from 'components/RwdCheckout/Shared/locales/UpdateError_en_US.js';
import UpdateErrorFR from 'components/RwdCheckout/Shared/locales/UpdateError_fr_CA.js';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;

const getText = getLocalisedDataFromResource(UpdateErrorEN, UpdateErrorFR);

const textResources = createStructuredSelector({
    pleaseUpdateInfoMessage: getTextFromResource(getText, 'pleaseUpdateInfoMessage')
});

const connectedUpdateError = connect(
    createSelector(textResources, texts => {
        return texts;
    })
);

const withUpdateErrorProps = wrapHOC(connectedUpdateError);

export default withUpdateErrorProps(UpdateError);
